<template>
  <div :style="wrapperStyle">
    <label v-if="fieldLabel" class="form-field-label" :for="uniqueTitle">{{ fieldLabel }}</label>
    <input
      :id="uniqueTitle"
      class="form-control"
      :name="uniqueTitle"
      :type="dateOnly ? 'date' : 'datetime-local'"
      :value="shownValue"
      :disabled="isReadonly"
      :aria-describedby="describedBy"
      @input="onInput"
    />
  </div>
</template>

<script>
import { inject, computed } from 'vue'
import { formattingToStyle } from '../../lib/client-rule-evaluator'
import { fieldValue, inputEventValue } from './form-controls'
import { browserTimeZone, storeDateOnly, toDateTimeLocal } from '../../../../shared/app-timezone'

export default {
  props: ['placeholder', 'uniqueTitle', 'fieldLabel', 'description', 'dateOnly'],
  setup (props) {

    const formFormatting = inject('formFormatting', null)
    const formReadonly = inject('formReadonly', null)
    const formValues = inject('formValues', null)
    const updateFormValue = inject('updateFormValue', null)

    const wrapperStyle = computed(() => {
      if (!formFormatting || !props.uniqueTitle) return {}
      const fmt = formFormatting[props.uniqueTitle]
      return fmt ? formattingToStyle(fmt) : {}
    })

    const isReadonly = computed(() => {
      if (!formReadonly || !props.uniqueTitle) return false
      return !!formReadonly[props.uniqueTitle]
    })

    const describedBy = computed(() => {
      return props.description ? `${props.uniqueTitle}-description` : undefined
    })

    const shownValue = computed(() => {
      const raw = fieldValue(formValues, props.uniqueTitle)
      if (raw == null || raw === '') return ''
      if (props.dateOnly) return storeDateOnly(raw) || String(raw).slice(0, 10)
      return toDateTimeLocal(raw, browserTimeZone()) || String(raw).slice(0, 16)
    })

    return { formFormatting, formReadonly, updateFormValue, wrapperStyle, isReadonly, describedBy, shownValue }
  },
  methods: {
    onInput (value) {
      if (this.updateFormValue) {
        this.updateFormValue(this.uniqueTitle, inputEventValue(value))
      }
    }
  }
}
</script>
